export default {"src":"/_next/static/media/Open.3c28fb28.svg","height":12,"width":12};